export const SET_PROMO = 'editor/SET_PROMO';
export const SET_LAYOUTS = 'editor/SET_LAYOUTS';
export const SET_LOGOS = 'editor/SET_LOGOS';
export const SET_PROMO_FIELD = 'editor/SET_PROMO_FIELD';
export const SET_PREVIEW_BOX = 'editor/SET_PREVIEW_BOX';
export const SET_CLONE_PROMO = 'editor/SET_CLONE_PROMO';
export const LOAD_FIELDS = 'editor/LOAD_FIELDS';
export const SET_PROMO_RESPONSE = 'editor/SET_PROMO_RESPONSE';
export const REDIRECT_TO_UPDATED_PROMO = 'editor/REDIRECT_TO_UPDATED_PROMO';
export const REDIRECT_TO_LIBRARY = 'editor/REDIRECT_TO_LIBRARY';